module.exports = __webpack_public_path__ + "static/Lipdukai_Vytis-5bd175f35c508621049c72f18f16905e.jpg";